<mat-dialog-content>
  <div fxLayout="column" class="searchWrapper" fxLayoutAlign="stretch stretch">
    <div class="searchInput px-2" fxLayout="column" fxLayoutAlign="center start">
      <mat-form-field appearance="fill" class="w-full mat-form-field-compact mat-form-field-no-hint">
        <input type="text" ignoreAutocomplete matInput [formControl]="search" cdkFocusInitial tabindex="0" />
        <mat-icon inline matSuffix>search</mat-icon>
      </mat-form-field>
    </div>
    <div fxLayout="column" class="searchContainer">
      <mat-list dense *ngIf="data$filtered | async as dataFiltered">
        <ng-container *ngFor="let item of dataFiltered; trackBy: trackId">
          <mat-list-item
            matRipple
            (click)="this.selectItem(item)"
            class="cursor-pointer"
            [class.bg-primary-2]="item.selected"
          >
            <div class="flex items-center space-x-2.5 flex-auto">
              <div class="h-8 w-8 flex items-center justify-center relative">
                <app-user-avatar
                  size="38px"
                  [ngClass]="{ 'rounded-full absolute': true, 'opacity-40': item.selected }"
                  [userId]="item.id"
                  defaultImageSource="/assets/img/default.png"
                ></app-user-avatar>
                <div
                  class="h-8 w-8 rounded-full flex items-center justify-center text-lg leading-8 text-center z-10"
                  *ngIf="item.selected"
                >
                  <mat-icon inline>check</mat-icon>
                </div>
              </div>
              <div class="flex flex-col leading-none flex-auto">
                <span>{{ item.name }}</span>
                <span class="text-sm mat-hint">{{ item.email }}</span>
              </div>
              <div class="flex items-center space-x-1.5">
                <div class="text-lg leading-none">
                  <mat-icon *ngIf="item.admin" inline class="text-primary cursor-default" matTooltip="Administrator"
                    >security</mat-icon
                  >
                </div>
              </div>
            </div>
          </mat-list-item>
        </ng-container>
        <ng-container *ngTemplateOutlet="noItems; context: { data: dataFiltered }"></ng-container>
      </mat-list>
      <ng-template #noItems let-dataFiltered="data">
        <div class="flex flex-col items-center justify-center p-2" *ngIf="dataFiltered.length === 0">
          <div class="mat-hint">{{ 'utils.noitems' | translate }}</div>
        </div>
      </ng-template>
    </div>
  </div>
</mat-dialog-content>
